import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntWarningIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 15.2L8 0.800003L16 15.2H0ZM13.4764 13.6842L8 3.83159L2.52364 13.6842H13.4764ZM7.2 7.20001V10.4H8.8V7.20001H7.2ZM7.2 12.8V11.2H8.8V12.8H7.2Z"
      />
    </SntIcon>
  );
};

export default SntWarningIcon;
